import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared.module';
import { WidgetsComponentsModule } from 'src/app/components/kit/widgets/widgets-components.module';
import { QuestionnaireOverviewComponent } from './questionnaire-overview.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { WorkflowModule } from 'src/app/workflow/workflow.module';
import { ElementsModule } from '../../../../components/elements/elements.module';
import { FeatherModule } from 'angular-feather';
import { WorkflowDirectivesModule } from '@app/workflow/directives/workflow-directives.module';

const COMPONENTS = [
	QuestionnaireOverviewComponent,
];

@NgModule({
	imports: [
		FormsModule,
		SharedModule,
		WidgetsComponentsModule,
		PerfectScrollbarModule,
		WorkflowModule,
		WorkflowDirectivesModule,
		ElementsModule,
		FeatherModule,
	],
	exports: [
	],
	declarations: [...COMPONENTS]
})
export class QuestionnaireOverviewModule {}
